const escapeHtml = (value = "") =>
  value.replace(/[&<>"']/g, (char) =>
    ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    })[char]
  );

const buildPopupHtml = ({ title, subtitle, header, table }) => `<!doctype html>
<html lang="pt-PT"><head><meta charset="utf-8"><title>${escapeHtml(title)}</title>
<style>
  @page { size: A4 landscape; margin: 20mm; }
  html, body { margin: 0; padding: 0; }
  body { font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif; font-size: 11px; color: #1f2937; }
  #root { padding: 12mm; }
  #matrix-print-header { display: block; margin-bottom: 10mm; }
  #matrix-print-header .grid { display: grid; grid-template-columns: auto 1fr auto; align-items: center; column-gap: 12px; }
  #matrix-print-header img { height: 40px !important; width: auto !important; object-fit: contain; }
  #matrix-print-header .text-center > div { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .matrix-title { font-size: 18px; font-weight: 700; text-align: center; margin-bottom: 3mm; color: #1f2937; }
  .matrix-subtitle { font-size: 12px; font-weight: 500; text-align: center; color: #6b7280; margin-bottom: 6mm; }
  table { border-collapse: collapse; width: 100%; border: 1px solid #d1d5db; }
  thead { background: #f3f4f6; }
  thead th { background: #f3f4f6; color: #1f2937; font-size: 11px; font-weight: 600; padding: 7px 8px; border: 1px solid #d1d5db; text-align: center; }
  thead th:first-child { text-align: left; min-width: 140px; }
  tbody td { padding: 6px 8px; border: 1px solid #e5e7eb; font-size: 11px; text-align: center; }
  tbody td:first-child { text-align: left; font-weight: 600; color: #1f2937; min-width: 140px; }
  tbody tr:nth-child(odd) { background: #fafafa; }
  tbody tr:nth-child(even) { background: #ffffff; }
  tbody tr:last-child { background: #f9fafb; font-weight: 600; }
  tbody tr:last-child td { border-top: 2px solid #d1d5db; border-bottom: 1px solid #d1d5db; padding: 7px 8px; }
  tfoot { display: none; }
</style></head>
<body><div id="root">
  <div id="matrix-print-header">${header}</div>
  <div class="matrix-title">${escapeHtml(title)}</div>
  <div class="matrix-subtitle">${escapeHtml(subtitle)}</div>
  <div class="matrix-table">${table}</div>
</div>
<script>window.onload = function(){ setTimeout(function(){ window.print(); window.close(); }, 200); };</script>
</body></html>`;

const MatrixPrintHook = {
  mounted() {
    this._onClick = (event) => {
      event.preventDefault();
      try {
        this._printMatrix();
      } catch (error) {
        console.warn("MatrixPrint failed:", error);
        window.print();
      }
    };

    this.el.addEventListener("click", this._onClick, { passive: false });
  },

  destroyed() {
    try {
      this.el.removeEventListener("click", this._onClick);
    } catch (_) {}
  },

  _printMatrix() {
    const targetId = this.el.dataset.printTarget;

    if (!targetId) {
      window.print();
      return;
    }

    const matrixEl = document.getElementById(targetId);

    if (!matrixEl) {
      window.print();
      return;
    }

    const matrixHTML = matrixEl.innerHTML.trim();

    if (!matrixHTML) {
      window.print();
      return;
    }

    const headerId = this.el.dataset.printHeader;
    const headerHTML = headerId ? (document.getElementById(headerId)?.innerHTML || "") : "";
    const title = this.el.dataset.printTitle || "Distribuição por refeitório e tipo";
    const subtitle = this.el.dataset.printSubtitle || "";

    const popupHTML = buildPopupHtml({
      title,
      subtitle,
      header: headerHTML,
      table: matrixHTML
    });

    const popup = window.open("", "_blank", "width=1100,height=750,scrollbars=yes");

    if (!popup) {
      window.print();
      return;
    }

    popup.document.open("text/html");
    popup.document.write(popupHTML);
    popup.document.close();
  }
};

export default MatrixPrintHook;
